import React, { Component } from 'react';
import styles from './Toolbar.module.scss';

class Toolbar extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles['wrapper']}>{children}</div>;
  }
}

export default Toolbar;
